/**
 * @module Select
 */
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import React, { Component } from "react";
import ReactSelect from "react-select";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import $ from "jquery";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: 0,
    maxWidth: 585,
    marginTop: "0px",
    float: "left",
  },
}))(Tooltip);

const styles = () => ({
  option: {
    fontSize: 11,
    padding: 5,
    fontWeight: 500,
  },
});

/**
 * Responsible for Re-usable and Customizable Select input fields.
 * @method Autocomplete
 * @returns {JSX} returns jsx.
 */
class AutoComplete1 extends Component {
  /**
   * Sets the state.
   * @constructor
   * @param {object} props
   * @property {object} props.value - value selected.
   */
  constructor(props) {
    super(props);
    this.state = {
      tooltip: this.props.value,
    };
  }

  /**
   * LifeCycle method update its internal state as the result of changes in props.
   * @function getDerivedStateFromProps
   * @param {*} nextProps - new changed props .
   * @param {*} prevState - previous state .
   * @returns {void}
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isDisabled) {
      $("#" + nextProps.isDisabled)
        .parent()
        .css("background-color", "#DCDCDC");
    } else {
      $("#" + nextProps.name)
        .parent()
        .css("background-color", "#FFFFFF");
    }

    if (prevState.tooltip && nextProps.value !== prevState.tooltip.value) {
      return {
        tooltip: nextProps.value,
      };
    }
  }
  render() {
    if (this.props.marginLeft == null) {
      $("#" + this.props.name)
        .parent()
        .css("margin-left", this.props.margin ? this.props.margin : "0px");
    }
    return (
      <React.Fragment>
        {this.props.label && !this.props?.show ? (
          <div
            class="dropdown-label"
            style={{
              marginBottom: "-10px",
              marginTop: "0.23rem",
              marginRight: "18px",
              lineHeight: "inherit",
              paddingLeft: "3px",
              marginLeft: this.props.margin ? this.props.margin : "0px",
            }}
          >
            {this.props.label}
          </div>
        ) : null}

        <LightTooltip
          id="tool"
          title={this.state.tooltip ? this.state.tooltip.label : ""}
        >
          <Autocomplete
            ListboxProps={{ style: { maxHeight: "15rem" } }}
            id={this.props.name}
            size="small"
            disableClearable
            defaultValue={this.props.defaultValue}
            disabled={this.props.disabled}
            name={this.props.name}
            options={this.props.options}
            getOptionLabel={(option) => option.label}
            style={{
              width: this.props.width ? this.props.width : "162px",
              marginLeft: this.props.marginLeft,
              paddingLeft: this.props.paddingLeft
                ? this.props.paddingLeft
                : null,
              marginBottom: "10px",
              margin: this.props.margin ? this.props.margin : null,
            }}
            value={
              this.state.tooltip ? this.state.tooltip : this.props.defaultValue
            }
            onChange={(event, newValue) => {
              if (newValue === null) {
                return;
              }
              this.setState({ tooltip: newValue });
              this.props.handleChange(newValue, this.props.name, this.props.vo);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "off",
                  spellcheck: "false",
                  "aria-autocomplete": "both",
                  "aria-haspopup": "false",
                  style: {
                    fontSize: this?.props?.fontSize
                      ? this?.props?.fontSize
                      : "12px",
                  },
                }}
                label={this.props.label ? this.props.label : ""}
                variant="outlined"
                style={{ background: "white", borderRadius: "5px" }}
                error={this.props.error ? this.props.error : false}
              />
            )}
            renderOption={(option) => (
              <React.Fragment>{option.label}</React.Fragment>
            )}
            className="control-label dropdown-input siderbar-input"
            classes={{
              option: this.props.classes.option,
            }}
          />
        </LightTooltip>
      </React.Fragment>
    );
  }
}
export const Select = React.memo((props) => {
  var labelData = props.textFieldProps;

  return (
    <div className="label-container">
      <ReactSelect
        label={props.label}
        className={props.className}
        value={props.propertyName || " "}
        onChange={props.handleChange}
        components={props.components}
        options={props.options}
        margin="normal"
        classes={props.classes}
        isDisabled={props.isDisabled}
        onBlur={props.onBlur ? props.onBlur : null}
        textFieldProps={labelData}
        width={props.width ? props.width : "150px"}
      />
    </div>
  );
});

function inputComponent({ inputRef, ...props }) {
  return (
    <div style={{ width: props.widthContainer }} ref={inputRef} {...props} />
  );
}

const Control = (props) => {
  return (
    <TextField
      style={{
        width: props.selectProps.width ? props.selectProps.width : "150px",
      }}
      id={props.id}
      InputProps={{
        inputComponent,
        inputProps: {
          autoComplete: "off",
          spellcheck: "false",
          "aria-autocomplete": "both",
          "aria-haspopup": "false",
          className: props.selectProps.classes.input,
          style: {
            fontSize: "12px",
            backgroundColor: props.selectProps.textFieldProps.isErrorField
              ? "yellow"
              : props.isDisabled
              ? "#ebebe4"
              : "white",
          },
          inputRef: props.innerRef,
          widthcontainer: props.selectProps.width
            ? props.selectProps.width
            : "150px",
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
};

const Option = (props) => {
  return (
    <MenuItem
      style={{ fontSize: "11px", padding: "0px 10px" }}
      selected={props.isFocused}
      component="span"
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
};

const Menu = (props) => {
  return (
    <Paper
      square
      style={{
        fontSize: "small",
        borderRadius: 5,
        maxHeight: 150,
        scrollBehavior: "smooth",
        overflow: "auto",
        marginTop: "0px",
        width: props.selectProps.width ? props.selectProps.width : "150px",
      }}
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
};

const ValueContainer = (props) => {
  return (
    <div
      className={props.selectProps.classes.valueContainer}
      style={{
        backgroundColor: props.selectProps.textFieldProps.isErrorField
          ? "yellow"
          : props.isDisabled
          ? "#ebebe4"
          : "white",
      }}
    >
      {props.children}
    </div>
  );
};

export const components = {
  Control,
  Menu,
  ValueContainer,
  Option,
};
export default withStyles(styles)(AutoComplete1);
